const createArchiveItem = (archiveItemData) => {
  return {
    archiveTitle: archiveItemData.archiveTitle,
    periods: archiveItemData.periods.map((period) => period),
  };
};

const createArchive = (archiveData) => {
  return archiveData.map((archiveDataItem) => createArchiveItem(archiveDataItem));
};


export {
  createArchiveItem,
  createArchive,
};
